import type { PersonalizedDiscountToken } from "../../../../aysa_api/features/discount/v1/discount.types";
import { Reader, Writer } from "protobufjs/minimal";

export const createBasePersonalizedDiscountToken =
  (): PersonalizedDiscountToken => {
    return {
      token: "",
    };
  };

export const decodePersonalizedDiscountToken = (
  reader: Reader,
  length: number
): PersonalizedDiscountToken => {
  const end = reader.pos + length;
  const message = createBasePersonalizedDiscountToken();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.token = reader.string();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodePersonalizedDiscountToken = (
  writer: Writer,
  message: PersonalizedDiscountToken
): Writer => {
  writer.uint32(10).string(message.token);

  return writer;
};
